<template>
  <div>
    <!-- Your template code here -->
    <div class="banner">
      <div>
        服务清单
      </div>
    </div>

    <div class="tag-box" v-for="item in serviceData" :key="item.serviceType">
      <h1 class="level1-tagname">{{ item.serviceType }}</h1>

      <div class="tag-card-box">
        <div class="tag-card" v-for="service in item.serviceList" :key="service.iid" @click="goServiceList(service.iid, service.tripleExternalChain)">
          <div class="service-box">
            <div class="service-item">
              <p>{{ service.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceListCard',
  // Your script code here
  data () {
    return {
      serviceData: [
        {
          serviceType: '政务服务事项清单',
          serviceList: [
            {
              iid: `qz`,
              name: '权责清单'
            },
            {
              iid: 'plc',
              name: '跑零次清单'
            },
            {
              iid: 'zdpyc',
              name: '最多跑一次清单'
            },
            {
              iid: 'tbsx',
              name: '通办事项清单'
            },
            {
              iid: 'ggfw',
              name: '公共服务清单'
            },
            {
              iid: 'msbs',
              name: '马上办事项清单'
            }
          ]
          // serviceList: [
          //   {
          //     iid: `/jiopweb/serviceList/qz?bannerType=list&areaCode=`,
          //     name: '权责清单'
          //   },
          //   {
          //     iid: '/jiopweb/serviceList/plc?bannerType=list&areaCode=',
          //     name: '跑零次清单'
          //   },
          //   {
          //     iid: '/jiopweb/serviceList/zdpyc?bannerType=list&areaCode=',
          //     name: '最多跑一次清单'
          //   },
          //   {
          //     iid: '/jiopweb/serviceList/tbsx?bannerType=list&areaCode=',
          //     name: '通办事项清单'
          //   },
          //   {
          //     iid: '/jiopweb/serviceList/ggfw?bannerType=list&areaCode=',
          //     name: '公共服务清单'
          //   },
          //   {
          //     iid: '/jiopweb/serviceList/msbs?bannerType=list&areaCode=',
          //     name: '马上办事项清单'
          //   }
          // ]
        },
        {
          serviceType: '收费清单',
          serviceList: [
            {
              iid: `${'http:'}//yjsgk.jsczt${'.cn/yjsgk/front/glwj'}/list.do?groupid=1&channel=14&date=2023&areaCode=320000000`,
              name: '行政事业性收费清单',
              tripleExternalChain: true
            }
          ]
        },
        {
          serviceType: '中介清单',
          serviceList: [
            {
              iid: 'https://sqt.jszwfw.gov.cn/intermediary',
              name: '权责清单',
              tripleExternalChain: true
            }
          ]
        }
      ]
    }
  },
  methods: {
    goServiceList (iid, tripleExternalChain) {
      const areaCode = JSON.parse(sessionStorage.getItem('JIOP_AREA'))[0].iid
      // const url = `${iid}${areaCode}`
      // window.open(url, '_self')
      if (tripleExternalChain) {
        window.open(iid, '_blank')
        return
      }
      this.$router.push({
        name: 'ServiceList',
        params: { type: iid },
        query: { areaCode }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/* Your scoped styles here */
.banner {
  height: 200px;
  background-image: url('../../assets/jiopweb/banner1.png');
  background-size: cover;
  background-position: center center;
  margin-bottom: 30px;
  div {
    width: 1200px;
    line-height: 200px;
    margin: auto;
    font-size: 40px;
    color: #fff;
    font-weight: 600;
  }
}

.tag-box {
  width: 1200px;
  margin: 0 auto;
    .level1-tagname {
      font-size: 30px;
      color: #333;
      margin-top: 10px;
    }
    .level2-tagname {
      font-size: 24px;
      color: #333;
      margin-top: 10px;
    }

    .tag-card-box {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      margin-top: 20px;
      // 为子元素中间添加间距
      gap: 2%;

      .tag-card {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        padding: 20px;
        box-shadow: 0 0 5px #ccc;
        width: 32%;
        cursor: pointer;

        .service-box {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          width: 100%;

          .service-item {
            width: 100%;
            box-sizing: border-box;
            p {
              font-size: 16px;
              margin-bottom: 0;
              // 文字过长时，隐藏多余部分
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 100%;
            }
          }
        }

        &:hover {
          background-color: #1890ff;
          color: #fff;
        }
      }

      .tag-card-active {
        background-color: #1890ff;
        color: #fff;
      }
    }
  }
</style>
